/**
 * Portal effect - dramatic 3D door-opening animation on page load.
 * Two panels split open like dungeon gates revealing the content behind.
 */

export function initPortal(container: HTMLElement): () => void {

  const overlay = document.createElement('div');
  overlay.className = 'portal-overlay';
  overlay.innerHTML = `
    <div class="portal-gate portal-gate-left">
      <div class="portal-rune">&#x2726;</div>
    </div>
    <div class="portal-gate portal-gate-right">
      <div class="portal-rune">&#x2726;</div>
    </div>
    <div class="portal-flash"></div>
  `;
  container.prepend(overlay);

  requestAnimationFrame(() => {
    overlay.classList.add('portal-open');
  });

  const gate = overlay.querySelector('.portal-gate-left') as HTMLElement;
  gate.addEventListener(
    'transitionend',
    () => {
      overlay.classList.add('portal-done');
      setTimeout(() => overlay.remove(), 300);
    },
    { once: true },
  );

  // Safety fallback if transitionend never fires
  setTimeout(() => overlay.remove(), 4000);

  return () => overlay.remove();
}
